import * as React from 'react';
import { queryNoTracking } from './DataService'
import { accentUtils } from './HelperService'
import { HubConnectionBuilder , LogLevel} from '@microsoft/signalr'

export const MessageTypes = {
    ShowContextChanged: "ShowContextChanged",
    ContextChanged: "ContextChanged",
    Tracking: "Tracking",
    InvoiceStatusChanged: "InvoiceStatusChanged",
    JobStatusChanged: "JobStatusChanged",
    CalendarChanged: "CalendarChanged",
    BulkUpdateChanged: "BulkUpdateChanged",
    UserChanged: "UserChanged",
    AppRestarted: "AppRestarted",
    RunChanged: "RunChanged",
    WorkflowBoardChanged: "WorkflowBoardChanged",
    ReportGenerated: "ReportGenerated",
    CommissionRunUpdate: "CommissionRunUpdate_",
    JobLinePriced: "JobLinePriced",
    PermanentCacheClear: "PermanentCacheClear",
    // A pricing account row changed (see EntityBusinessRules.OnSavePricingAccount);
    // the client refetches PricingAccounts_InUse and its account keyword rows.
    PricingAccountsChanged: "PricingAccountsChanged",
    JobViewRequest: "JobViewRequest",
    JobViewNotify: "JobViewNotify",
    JobViewDone: "JobViewDone",
    ChatUpdate: "ChatUpdate",
    // Async AI assistant turns: heartbeats while the detached server task runs and
    // the final done/failed signal (see assistantChatApi.js).
    AssistantTurn: "AssistantTurn",
    // SWF import background task: phase updates while it runs and the final
    // result/error (see SWFImportProgressDlg.js).
    SWFImportUpdate: "SWFImportUpdate",
    SWFImportComplete: "SWFImportComplete",
    // Publish Drafts background task: one update per item, then the batch result/error
    // (see PublishDraftsDlg.js).
    PublishDraftsUpdate: "PublishDraftsUpdate",
    PublishDraftsComplete: "PublishDraftsComplete",
    // Upload To Marketplace background task: one update per item, then the run's
    // result/error (see MarketplaceUploadDlg.js).
    MarketplaceUploadUpdate: "MarketplaceUploadUpdate",
    MarketplaceUploadComplete: "MarketplaceUploadComplete"
};

const logLevel = {
        Trace: LogLevel.Trace,
        Debug: LogLevel.Debug,
        Information: LogLevel.Information,
        Warning: LogLevel.Warning,
        Error: LogLevel.Error,
        Critical: LogLevel.Critical,
        None: LogLevel.None,
}[process.env.REACT_APP_SIGNALR_LOG_LEVEL] ?? LogLevel.Information;

class MessageService {

    token = null;
    clients = {};




    register(key, messageType, callback) {

        var msgClient = this.clients[messageType];
        if (accentUtils.isNull(msgClient)) {
            this.clients[messageType] = {};
            msgClient = this.clients[messageType]
        }
        msgClient[key] = callback;
    }

    unregister(key, messageType) {

        var msgClient = this.clients[messageType];
        if (accentUtils.isNull(msgClient)) {
            this.clients[messageType] = {};
            msgClient = this.clients[messageType]
        }

        if (!accentUtils.isNull(msgClient[key])) {
            delete msgClient[key];
        }

        
    }

    notify(messageType, message) {

        var msgClient = this.clients[messageType];

        if (!accentUtils.isNull(msgClient)) {

            Object.keys(msgClient).map(key => {

                if (!accentUtils.isNull(msgClient[key])) {

                    msgClient[key](message, key);

                }


            });
            
        }


    }

    async Initialize() {

        try {

            this.token = await queryNoTracking("Messages_GetToken").getFirstOrDefault();

            var options = {
                accessTokenFactory: () => this.token.Token,
            };

            const connection = new HubConnectionBuilder()
                .withUrl(this.token.URL, options)
                .withAutomaticReconnect([0, 1000, 5000, null])
                .configureLogging(logLevel)
                .build();
            connection.on('newMessage', (messageKey, message) => {

                if (messageKey.startsWith(MessageTypes.CommissionRunUpdate)) {
                    this.notify(MessageTypes.CommissionRunUpdate, message);
                } else {
                    this.notify(messageKey, message);
                }


            });

            connection.start()
                .catch(console.error);

        } catch (e) {

        }
    }

}


export function useMessage(key, messageType) {

    const [value, setValue] = React.useState(null);

    const onReceive = React.useCallback(e => {
        setValue(e);
    }, []);

    React.useEffect(() => {

        Helper.register(key, messageType, onReceive);

        return () => {
            Helper.unregister(key, messageType);
        };
    }, []);

    return value;
}

export const Helper = new MessageService();

